import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ProductsSelectorFacade } from '@ridango/components/lib/products-selector/+state/products-selector.facade';
import { AppStartupService, Product } from '@ridango/core';
import { BaseComponent } from '@ridango/core';
import { takeUntil } from 'rxjs/operators';
@Component({
    selector: 'rwidget-product-passenger-count-selector',
    templateUrl: './product-passenger-count-selector.component.html',
    styleUrls: ['./product-passenger-count-selector.component.scss']
})
export class ProductPassengerCountSelectorComponent extends BaseComponent implements OnInit, OnDestroy {
    @Input() products: Product[];
    maxProducts = this.env.MAX_DRT_PASSENGERS ? this.env.MAX_DRT_PASSENGERS : 4;
    productPassengerCount = new Map<number, number>();

    constructor(
        @Inject('ENV') public env: any,
        public appStartupService: AppStartupService,
        private productsSelector: ProductsSelectorFacade,
        private translate: TranslateService
    ) {
        super();
    }

    ngOnInit(): void {
        this.productsSelector.selected$.pipe(takeUntil(this.componentDestroyed$)).subscribe((selected) => {
            this.productPassengerCount = selected;
        });
    }

    addTicket(productId: number) {
        if (!this.productAddingIsDisabled()) {
            this.productsSelector.addProduct(productId);
        }
    }

    productAddingIsDisabled(): boolean {
        let selectedProducts = 0;
        for (const key in this.productPassengerCount) {
            selectedProducts += this.productPassengerCount[key];
        }

        return selectedProducts >= this.maxProducts;
    }

    getProductSelectedAmount(productId: number): number {
        const count = this.productPassengerCount[productId];

        return count ? count : 0;
    }

    removeTicket(productId: number) {
        if (!this.productRemovingIsDisabled(productId)) {
            this.productsSelector.removeProduct(productId);
        }
    }

    productRemovingIsDisabled(productId: number): boolean {
        return this.getProductSelectedAmount(productId) <= 0;
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
